import styles from './logs.module.css';
import { useState, useEffect, useMemo} from 'react';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';
import Notification from '../shared/Notification';


const Logs = () => {
    const token = useMemo(() => localStorage.getItem('token'), []);
    const { userId } = useAuth();
    const [notification, setNotification] = useState('');
    const [logs, setLogs] = useState([]);

    useEffect(() => {
        if (!token) {
            setNotification('Unauthorized. Token unavailable.');
            window.location.href = '/admin';
            return;
        }

         const fetchLogs = async () => {
            try {
                const response = await axios.get('/api/utils/logs/all-logs', {
                    headers: { Authorization: `Bearer ${token}` },
                });
                setLogs(response.data);
            } catch (error) {
                // console.error('Error fetching logs:', error);
            }
        };

        const verifyAdmin = async () => {
            try {
                const response = await axios.get('/api/utils/logs/verify-admin', {
                    headers: { Authorization: `Bearer ${token}` },
                });
                // const data = await response.json();

                if (!response.data.isAdmin) {
                    setNotification('Unauthorized. Please log in as admin to view logs.');
                    window.location.href = '/admin';
                } else {
                    fetchLogs(); // Only fetch logs if admin is confirmed
                }
            } catch (error) {
                // console.error('Error verifying admin:', error.message);
                window.location.href = '/admin';
            }
        };

       

        verifyAdmin();
    }, [token]);
    return (
        <div className={styles.logsPage}>

        {notification && <Notification message={notification} onClose={() => setNotification('')} />}

            <h2>Logs</h2>
            <div className={styles.logsContainer}>
               <div className={styles.logEntry}>
                {logs.length === 0 && <p>No logs found.</p>}
                <button className={styles.refreshButton} onClick={() => window.location.reload()}>Refresh Logs</button>
                <button className={styles.backButton} onClick={() => window.location.href = '/admin'}>
                    Back to Admin Dashboard
                </button>
                {logs.map((log) => (
                    <div key={log._id} className={styles.logEntry}>
                        <p><strong>Email/Phone:</strong> {log.emailOrPhone}</p>
                        <p><strong>Error:</strong> {log.error}</p>
                        <p><strong>Type:</strong> {log.type}</p>
                        <p><strong>Date:</strong> {new Date(log.createdAt).toLocaleString()}</p>
                    </div>
                ))}
                </div>
            </div>
        </div>
     );
}

export default Logs;